import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { MirrorService } from 'services/MirrorService';

import {
  QueryKeys,
  useSystemSearchQueries,
} from 'hooks/useSystemSearchQueries';

// * this hack needed for mainstream analytics matching
// ! important: this hook should be fired before all analytics hooks

export const useClickIdHack = () => {
  const { search } = useLocation();
  const history = useHistory();

  const { getClickIdQuery, getFbclidQuery } = useSystemSearchQueries();

  const { value: clickId } = getClickIdQuery();
  const { value: fbclid } = getFbclidQuery();

  useEffect(() => {
    if (MirrorService.isSimpleDates && fbclid && !clickId) {
      history.replace({
        search: `${search}&${QueryKeys.ClickId}=${fbclid}`,
      });
    }
  }, [clickId, fbclid, history, search]);
};
